import { Box } from "@mui/material";
import { FilterButtonStyled } from ".";


export const FilterButton = ({
    toggleDrawer,
    hasActiveFilters,
}: {
    toggleDrawer: (open: boolean) => () => void;
    hasActiveFilters?: boolean;
}) => {
    return (<FilterButtonStyled onClick={toggleDrawer(true)}>
        <Box sx={{ position: 'relative', height: 24 }}>
            <i className="fi-br-filter" style={{ fontSize: '20px', lineHeight: '16px' }} />
             {hasActiveFilters && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: theme => theme.palette.error.main,
                    }}
                />
            )}
        </Box>
    </FilterButtonStyled>)
};
